export default "__VITE_ASSET__CrDb8C7I__"